import { CaretRightIcon, FolderIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'
import type { CommunityEssentialFolderModel } from '@/models'

import * as S from './client-folder-item.styled'

interface ClientFolderItemProps {
  folder: CommunityEssentialFolderModel
  onNavigate: (folder: CommunityEssentialFolderModel) => void
}

export const ClientFolderItem = ({ folder, onNavigate }: ClientFolderItemProps) => {
  return (
    <S.Row onClick={() => onNavigate(folder)}>
      <S.IconWrapper>
        <Icon icon={FolderIcon} size="2rem" />
      </S.IconWrapper>
      <Typography breakLines={1} size="text-small" weight="medium">
        {folder.name}
      </Typography>
      <S.RightSection>
        <Icon icon={CaretRightIcon} size="1.6rem" />
      </S.RightSection>
    </S.Row>
  )
}
